export type ClientTypeFilterValue = "direct" | "indirect";

export type FilterClientType = ClientTypeFilterValue | "all";

export const ALL_CLIENT_TYPES: ClientTypeFilterValue[] = ["direct", "indirect"];

export const toFilterClientType = (
  clientTypes: readonly string[] | null | undefined,
): FilterClientType =>
  clientTypes?.length === 1 ? (clientTypes[0] as ClientTypeFilterValue) : "all";

export const includesSharedClients = (
  clientTypes: readonly string[] | null | undefined,
) => clientTypes?.includes("indirect") ?? false;
